<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="setDealer">
            <b-form-group :label="$t('person.login')" label-cols-sm="4">
                <b-form-input :value="this.login" required disabled></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('general.dealer')" label-cols-sm="4">
                <multiselect v-model="selectedDealer" :options="dealers" @input="dealerSelected"
                            :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findDealer" :internal-search="false"
                            :custom-label="dealerLabel" :placeholder="$t('person.typeIin')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
export default {
    name: 'PersonSetDealerForm',
    props: {
        login: String,
        dealerId: Number
    },
    data () {
        return {
            showAlert: false,
            showSuccessAlert: false,
            alert: '',
            formData: {
                login: this.login,
                dealerId: this.dealerId
            },
            selectedDealer: null,
            dealers: []
        }
    },
    mounted: function () {
        this.getCurrentDealer(this.dealerId)
        this.formData.dealerId = this.dealerId
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        getCurrentDealer: function (dealerId) {
            this.$request.sendRequest(this, this.$appConfig.apiUrls.dealer.getAll,
                { dealerid: dealerId }, result => {
                    this.selectedDealer = result[0]
                }, this.displayAlert)
        },
        findDealer: function (query) {
            this.$request.sendRequest(this, this.$appConfig.apiUrls.dealer.getAll,
                { iin: query }, result => {
                    this.dealers = result
                }, this.displayAlert)
        },
        dealerSelected: function (value) {
            this.formData.dealerId = value ? value.id : null
        },
        dealerLabel: function ({ iin, name }) {
            return `${iin} - ${name}`
        },
        setDealer: function () {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.person.setDealer,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('person.dealerSetMessage')
                }, this.displayAlert)
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
